<style scoped>
</style>

<template>
  <div>
    <div class='h-toolbarBg'>
      <div class="e-control e-toolbar " >
        <div class="e-toolbar-items">            
          <div class="e-toolbar-item " >
              <div class="e-input-group e-search h-pm-search-left">
              <input class="e-input" :placeholder='$t("Pm.name")' v-model='searchString' maxlength="255"/>
              <span class="hero-icon hero-icon-search"></span>
              </div>
          </div>            
        </div>
      </div>
    </div>
    <div >
      <ejs-grid ref="grid" :dataSource="searchDataForList" class="h100-60 h-scroll" :allowPaging="false"  height='calc(100vh - 280px)'>
        <e-columns>
          <e-column field="counterCodeCn2" :headerText='$t("Pm.name")' textAlign="center"  width="40%"  clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="counterUnitCn2" :headerText='$t("Pm.unit")' textAlign="center" width="10%" clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="counterTypeMode" :headerText='$t("Pm.mode")' textAlign="center" width="10%" clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="counterInvalidTime" :headerText='$t("Pm.invalidTime")' textAlign="center" width="25%" clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="FailureOrNo" :headerText='$t("Pm.realOrNo")' textAlign="center" width="15%" clipMode="EllipsisWithTooltip" :template='realTemplate'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getData()' :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>
import { Reorder, Resize, Toolbar, Page } from '@syncfusion/ej2-vue-grids';
import realTemplate from './realTemplate';

const NONREAL = 1;
const REAL = 2;
const REALORNO = 3;

export default {
  name: 'calculatorList',
  components: { realTemplate },
  props: {
    nodeParam: {
      netypeid: '',
      measureobjecttypecode: '',
      countertypeid: '',
      neversionid: '',
      text: {},
      isLeaf: false
    }
  },
  data() {
    return {
      dataForList: {},
      searchString: '',
      toolbar: [],
      pageSettings: {
        currentPage: 1,
        pageSize: 19,
        totalRecordsCount: 0,
        pageCount: 10
      },
      realTemplate(args) {
        return {
          template: realTemplate
        };
      },
      oldSearchString:''
    };
  },
  methods: {
    getData() {
      const This = this;
      This.pageSettings.currentPage = This.$refs.pager.ej2Instances.currentPage;
      this.$axios.post('/lte/pm/indicator/sysKpiListData.html', {
        page: {
          pageNo: This.pageSettings.currentPage,
          pageSize: This.pageSettings.pageSize
        },
        netypeid: this.nodeParam.netypeid,
        measureobjecttypecode: this.nodeParam.measureobjecttypecode,
        countertypeid: this.nodeParam.countertypeid,
        neversionid: this.nodeParam.neversionid,
        systemId: '1',
        timecycle: 2,
        indicatorname:this.oldSearchString
      }).then((response) => {
        if (response.status !== 200 || response.data === undefined) {
          return;
        }
        if (response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          This.pageSettings.totalRecordsCount = result.totalCount;
          This.pageSettings.currentPage = result.pageNo;
          This.dataForList = result.result;
          for (let item of this.dataForList) {
            switch (item.counterTimelyMod) {
              case REAL:
                item.FailureOrNo = `${this.$t('Pm.real')}`;
                break;
              case NONREAL:
                item.FailureOrNo = `${this.$t('Pm.nonReal')}`;
                break;
              case REALORNO:
                item.FailureOrNo = `${this.$t('Pm.realOrNo')}`;
                break;
              default:
                item.FailureOrNo = `${this.$t('Pm.nonReal')}`;
                break;
            }
            item.counterUnitCn2 = (this._i18n.locale === 'zh')?item.counterUnitCn:item.counterUnitEn;
            item.counterCodeCn2 = (this._i18n.locale === 'zh')?item.counterCodeCn:item.counterCodeEn;
          }
        } else {
          console.log('error', response.data.errorCode);
        }
      }).catch((error) => { // 请求失败处理
        console.log('error', error);
      });
    }

  },
  mounted() {
  },
  provide: {
    grid: [Reorder, Resize, Toolbar, Page]
  },

  computed: {
    // 计算数学，匹配搜索
    searchDataForList(val) {
      const This = this;
      const searchString = This.searchString.trim().toLowerCase();
      if (this.oldSearchString === searchString) {//!searchString || 
        return this.dataForList;
      }

      this.oldSearchString = searchString;
      This.$refs.pager.ej2Instances.currentPage = 1;
      this.getData();

      return this.dataForList;
    }
  },
  watch: {
    nodeParam(val) {
      this.nodeParam = val;
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.getData();
    }
  }
};
</script>
